// src/components/ProcessNumber.tsx
import React from "react";
import { cn } from "@/lib/utils";

interface ProcessNumberProps {
  number: string;
  active?: boolean;
  viewStyle?: 'compact' | 'detailed'; // Ny prop
}

const ProcessNumber: React.FC<ProcessNumberProps> = ({ 
  number, 
  active = false,
  viewStyle = 'compact' // Standard är compact view
}) => (
  <div
    className={cn(
      "flex-shrink-0 min-w-[1.5rem] text-center font-mono text-xs font-medium",
      active && viewStyle === 'compact'
        ? "text-gray-900" // Mörk text i compact view (ljus bakgrund)
        : active && viewStyle === 'detailed'
        ? "text-orange-300" // Orange text i detailed view (mörk bakgrund)
        : "text-[#CE5325]" // Standard orange färg när inte aktiv
    )}
  >
    {number}
  </div>
);

export default ProcessNumber;